import { Validator } from './Validator';
import { ValidationError } from './ValidatorError';
// import { Validator, VARIABLE_VALIDATION_REGEX } from './Validator';
// import { ExecuteScriptActionSettings } from '../ExecuteScriptActionSettings';
// import { ValidationError } from './ValidatorError';
export class SetVariableActionSettingsValidator extends Validator {
    validate(model) {
        if (!model.variable ||
            (model.variable && !model.variable.match(/^([a-zA-Z0-9]+)$/))) {
            throw new ValidationError('No variable name');
        }
    }
}
